import RoutesPreInscricao from "@/libs/endPoint/rh/PreInscricaoRoutes.js";
import routes from "@/libs/endPoint/rh/InscricaoDistribuicaoRoutes.js";
import routesServidor from "@/libs/endPoint/rh/servidorRoutes.js";
import routeDatasDistribuicao from "@/libs/endPoint/rh/DatasDistribuicaoRoutes.js";
import routeItensDistribuicao from "@/libs/endPoint/rh/ItenInscricaoDistribuicaoRoutes";
import ApiServices from "@/services/uteis/ApiServices.js";
import store from "@/store";
class RemocaoServices {
  constructor() {
    this.routes = routes;
    this.ApiServices = ApiServices;
    this.routesServidor = routesServidor;
    this.routeDatasDistribuicao = routeDatasDistribuicao;
    this.routeItensDistribuicao = routeItensDistribuicao;
    this.RoutesPreInscricao = RoutesPreInscricao;
  }

  async validarServidor(cpf, ano) {
    try {
      const url = this.RoutesPreInscricao.validarServidor(cpf, ano);
      const { data } = await this.ApiServices.get(url);
      return data;
    } catch (error) {
      console.error("Erro ao validar servidor:", error);
      throw error;
    }
  }
  async localizarMatriculas(cpf) {
    try {
      const url = `${this.routesServidor.matricula}/por-cpf/${cpf}`;

      const { data } = await this.ApiServices.get(url);
      return data;
    } catch (error) {
      console.error("Erro ao localizar matrículas:", error);
      throw error;
    }
  }
  async obterDatasDistribuicao(ano) {
    try {
      const url = this.routeDatasDistribuicao.main;

      const { data } = await this.ApiServices.get(url, { ano: ano });

      return data;
    } catch (error) {
      console.error("Erro ao obter datas de distribuição:", error);
      throw error;
    }
  }

  async bootstrapListarDatasDistribuicao(ano) {
    try {
      const url = this.routeDatasDistribuicao.main;
      let lista = store.getters["remocao/datasRemocao"];
      if (!lista || lista.length === 0) {
        const { data } = await this.ApiServices.get(url, { ano: ano });
        store.commit("remocao/setDatasRemocao", data);
        lista = data;
      }
      return lista;
    } catch (error) {
      console.error("Erro ao obter datas de distribuição:", error);
      throw error;
    }
  }

  async salvarPreInscricao(payload) {
    try {
      const url = this.RoutesPreInscricao.solicitarInscricao;
      const { data } = await this.ApiServices.post(url, payload);
      return data;
    } catch (error) {
      console.error("Erro ao salvar pré-inscrição:", error);
      throw error;
    }
  }
  async confirmarInscricao(payload) {
    try {
      const url = this.RoutesPreInscricao.finalizarInscricao;

      const { data } = await this.ApiServices.post(url, { id: payload });
          return data;
    } catch (error) {
      console.error("Erro ao salvar pré-inscrição:", error);
      throw error;
    }
  }
  async inscreverEmData(payload) {
    try {
      const url = this.routeItensDistribuicao.inserirChecked;
      const { data } = await this.ApiServices.post(url, payload);
      return data;
    } catch (error) {
      console.error("Erro ao salvar pré-inscrição:", error);
      throw error;
    }
  }

  async desistirData(idItem) {
    try {
      const url = this.routeItensDistribuicao.remove(idItem);
      const { data } = await this.ApiServices.delete(url);
      return data;
    } catch (error) {
      console.error("Erro ao desistir da data:", error);
      throw error;
    }
  }

  async uploadDocumentoInscricao(payload, cpf, ano) {
    try {
      const url = this.routes.upload(ano, cpf);
  
      const { data } = await this.ApiServices.post(url, payload);
      await this.listarUploadsInscricao(ano, cpf);
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        // Mostra erro detalhado do backend
        console.error("Erro ao fazer upload do documento:", error.response.data);
        throw error.response.data; // ou retorne como preferir
      } else {
        console.error("Erro ao fazer upload do documento:", error);
        throw error;
      }
    }
  }

  async listarUploadsInscricao(ano, cpf) {
    try {
      const url = this.routes.listarUloads(ano, cpf);
         const response = await this.ApiServices.get(url);
      store.commit("remocao/setListaUploadsInscricao", response.data);
    } catch (error) {
      console.error("Erro ao listar uploads da inscrição:", error);
      throw error;
    }
  }
  //metodo para remover upload
  async deletarUploadInscricao(nomeArquivo, cpf, ano) {
    try {
      const url = this.routes.removerUpload(ano, cpf, nomeArquivo);
         const { data } = await this.ApiServices.delete(url);
      return data;
    } catch (error) {
      console.error("Erro ao deletar upload da inscrição:", error);
      throw error;
    }
  }
}
export default new RemocaoServices();
